import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useIsAuthenticated, useIsFeatureWhitelisted } from 'mf_core/auth';
import { useFeatureFlagBase } from './use-feature-flag-base';
import { checkListForPath } from '../app/injectors/utils';

//Config documentation:
// https://imonline.atlassian.net/wiki/spaces/GLAD/pages/3285942926/CCAI+Chatbot+Live+Chat
export function useIsUjetChatbotEnabled(isCloudChat: boolean) {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();
  const pathname = location.pathname.toLowerCase();

  const isFeatureWhitelisted = useIsFeatureWhitelisted();

  const { boValues: value, isReady } = useFeatureFlagBase();

  const isWhitelistedReseller =
    value['CCAI_Chatbot_WhitelistedResellers'] === 'true';

  const isUniteChatbot =
    isFeatureWhitelisted('CMP') &&
    pathname.includes('/general/contact-us') &&
    isReady &&
    Boolean(value['CCAI_UNITE_Disabled']) === false;

  const pathWhitelist: string[] = useMemo(() => {
    return (
      (value['CCAI_Paths_Whitelist'] &&
        value['CCAI_Paths_Whitelist']?.toLowerCase().split(',')) ||
      []
    );
  }, [value]);

  const isValidPath = useMemo(() => {
    if (!isReady || !isWhitelistedReseller) return false;

    if (pathWhitelist[0] === '*' || pathWhitelist.length === 0) return true;

    const currentPathWhitelisted = checkListForPath(pathWhitelist, pathname);
    return currentPathWhitelisted;
  }, [isReady, isWhitelistedReseller, pathWhitelist, pathname]);

  const translationKeys: string[] = getTranslationKeys();

  return {
    isEnabled: isChatbotEnabled(),
    isUniteChatbot,
    isValidPath,
    translationKeys,
  };

  function getTranslationKeys(): string[] {
    return isUniteChatbot
      ? (isReady && value['CCAI_UNITE_Translation_Keys']?.split(',')) || []
      : (isReady && value['CCAI_Translation_Keys']?.split(',')) || [];
  }

  function isChatbotEnabled() {
    return isCloudChat
      ? isUniteChatbot
      : isAuthenticated && isReady && isWhitelistedReseller;
  }
}
